import axiosHttpClient from "../axiosHttpClient";

export function post(data: any) {
	return axiosHttpClient.post('/strength-class', data);
}

export function getAll() {
	return axiosHttpClient.get('/strength-classes');
}

export function getOne(id: number) {
	return axiosHttpClient.get('/strength-class/one/'+id.toString());
}

export function deleteAllowed(id: number) {
	return axiosHttpClient.get('/strength-class/delete-allowed/'+id.toString());
}

export function remove(id: number) {
	return axiosHttpClient.get('/strength-class/delete/'+id.toString());
}

